import { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import Toolbar from "@mui/material/Toolbar";

import CustomDrawer from "../components/CustomDrawer";

import Button from "@mui/material/Button";
import { useLocation } from 'react-router-dom';


import ButtonGroup from "@mui/material/ButtonGroup";

import AddIcon from "@mui/icons-material/Add";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";


import axios from "axios";
import IncidentSeverity from "../components/Wellness Chart/IncidentSeverity";
import IncidentChart from "../components/Wellness Chart/IncidentChart";
import IncidentTrend from "../components/Wellness Chart/IncidentTrend";
import IncidentConsequences from "../components/Wellness Chart/IncidentConsequences";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Layout from "../components/layout/Layout";
import RemoveIcon from '@mui/icons-material/Remove';

const HealthandSafetyDashboard = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [newPerformance, setnewPerformance] = useState("");
  const [, setAnchorEl] = useState(null);
    const location = useLocation();
  const { name } = location.state || {};

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };






  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
    <Layout >
      <div>
      {name && <h1 className="ms-5 text-warning">{name}</h1>}
      <Box sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        m: 5,
        zIndex: 1300, 
      }}>
        <ButtonGroup
            sx={{
              marginTop: 3,
              marginLeft:7,
              justifyItems: "center",
              backgroundColor: "#FD6262",
            }}
            variant="contained"
            aria-label="Basic button group"
          >
            <Button
              sx={{
                backgroundColor: "#FD6262",
                display:"flex",
                justifyItems:"center",
                alignItems:"center",

                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <RemoveIcon/>
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <AddIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDownloadClick}
            >
              <ArrowCircleDownIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDrawerToggle}
            >
              <RemoveRedEyeIcon/>
            </Button>
          </ButtonGroup>
          
        </Box>
     

        <CustomDrawer
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
          />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            paddingTop: "64px",
            paddingRight: `${isDrawerOpen ? "20%" : "0px"}`,
          }}
        >
          <Toolbar />
          <Box component="section" mt={4}>
          <Container>
      <Grid container spacing={4} style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Grid item xs={12} md={6} style={{ display: 'flex' }}>
          <Paper
            sx={{ padding: 4, backgroundColor: "#050945", flex: 1 }}
            elevation={3}
          >
            <IncidentChart />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} style={{ display: 'flex' }}>
          <Paper
            sx={{ padding: 4, backgroundColor: "#050945", flex: 1 }}
            elevation={3}
          >
            <IncidentTrend/>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} style={{ display: 'flex' }}>
          <Paper
            sx={{ padding: 4, backgroundColor: "#050945", flex: 1 }}
            elevation={3}
          >
            <IncidentSeverity />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} style={{ display: 'flex' }}>
          <Paper
            sx={{ padding: 4, backgroundColor: "#050945", flex: 1 }}
            elevation={3}
          >
            <IncidentConsequences />
          </Paper>
        </Grid>
      </Grid>
    </Container>
          </Box>
        </Box>
      </div>
      </Layout>
    </>
  );
};

export default HealthandSafetyDashboard;
